import {sendGoalToMetrika} from '@yandex-int/pythia-libs';

import cfg from 'client/common/utils/client-config';

interface MetrikaErrorGoal {
    [key: string]: string;
}

const METRIKA_ERROR_GOAL: MetrikaErrorGoal = {
    survey: 'open_form__fail',
    statistics: 'open_statistics__fail'
};

export function handleErrorStatus(status: number): void {
    if (status >= 400) {
        const [, box, page] = window.location.pathname.split('/');

        if (
            box === 'brandlift' &&
            Object.keys(METRIKA_ERROR_GOAL).includes(page) &&
            cfg.metrika.counters && cfg.metrika.counters.brandlift
        ) {
            void sendGoalToMetrika(cfg.metrika.counters.brandlift, METRIKA_ERROR_GOAL[page]);
        }
    }
}
